module.exports = __webpack_public_path__ + "static/img/3-04.849bb746.jpg";